<template>
  <a-modal
    :title="modalData.modalTitle"
    :visible="modalData.show"
    :footer="null"
    :zIndex="2"
    @cancel="handleCancel"
  >
    <div class="content-form">
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" >
        <a-form-item label="输入课程号：">
          <a-input
            style="width: 200px;"
            placeholder="请输入课程号"
            autocomplete="off"
            v-decorator="[
              'courseCode', {
                initialValue: courseItem.courseNo,
                rules: [
                  { required: true, message: '请输入课程号！' },
                  {
                    validator: this.checkCourseCode
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="课程信息：">
          <a-input
            style="width: 200px;"
            placeholder="请输入课程信息"
            autocomplete="off"
            v-decorator="[
              'courseName', {
                initialValue: courseItem.courseName
              }]"
            disabled
          />
        </a-form-item>
        <a-form-item label="选择讲师：">
          <a-select
            v-decorator="[
              'selectedTeacherId',
              {
                initialValue: courseItem.teacherId,
                rules: [
                  { required: true, message: '请选择讲师' },
                ],
              },
            ]"
            style="width: 200px;"
            placeholder="请选择讲师"
            @change="handleSelectTeacherChange"
          >
            <a-select-option
              v-for="item in teacherList"
              :key="item.userId"
              :value="item.userId"
            >
              {{ item.userName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="对外展示信息：">
          <a-input
            style="width: 200px;"
            placeholder="请输入对外展示信息"
            autocomplete="off"
            :maxLength="20"
            v-decorator="[
              'h5DisplayContent', {
                initialValue: courseItem.h5DisplayContent
              }]"
          />
        </a-form-item>
        <a-form-item label="上传自定义封面：">
          <div :class="`btn-update-cover ${imageUrl?'has-image':''}`" :style="`background-image: url('${imageUrl}')`">
            <div class="update-mask">
              <i :class="`icon-upload ${uploadLoading ? 'icon-loading' : ''} `"></i>
              <span class="btn-text">{{ uploadLoading ? '上传中...' : '自定义上传' }}</span>
            </div>
            <div class="update-wrap" :style="`display:${uploadLoading ? 'none' : 'block'}`">
              <UploadImg @updateUpload="updateUpload"/>
            </div>
          </div>
          <p class="upload-cover-tip">支持jpg/gif/png/webp格式，建议尺寸750x422px，不超过5M</p>
        </a-form-item>
      </a-form>
    </div>
    <div class="footer">
      <div class="btn btn-cancel" @click="handleCancel">取消</div>
      <div :class="`btn btn-ok ${uploadLoading || !form.getFieldsValue().courseCode || !form.getFieldsValue().selectedTeacherId ? 'btn-ok-disabled' : ''}`" @click="handleOk">确定</div>
    </div>
  </a-modal>
</template>

<script>
import UploadImg from './UploadImg2.vue'
export default {
  name: 'AddSpocCourse',
  components: {
    UploadImg
  },
  props: {
    activityDetail: {
      type: Object,
      default: () => ({})
    },
    activityId: String | Number,
    modalData: {
      type: Object,
      default: () => ({})
    },
    courseItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedTeacher: {},
      teacherList: [], // 讲师列表
      imageUrl: '',
      uploadLoading: false,
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  watch: {
    courseItem: {
      async handler(nVal) {
        // 更新表单
        this.imageUrl = nVal.imageUrl
        this.$nextTick(async () => {
          this.form.setFieldsValue({
            courseCode: nVal.courseNo,
            courseName: nVal.courseName,
            h5DisplayContent: nVal.h5DisplayContent,
            selectedTeacherId: nVal.teacherId
          })
          // 获取新的教师列表等
          if (nVal.courseNo) {
            const res = await this.$http.getAidedTeachCourseInfo({
              courseNo: nVal.courseNo,
            })
            if (res.code === 200) {
              const { teacherInfos } = res.rt || {}
              this.teacherList = teacherInfos || []
              this.selectedTeacher = this.teacherList.find(i => i.userId == nVal.teacherId)
            }
          }
        })
      },
      deep: true
    },
  },
  methods: {
    checkCourseCode(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      if (!(/^(k|K)/.test(value))) {
        callback('请输入以"K"或"k"开头的课程号！')
        return
      }
      this.courseCodeChange(value, (rt) => {
        if (rt.resultStatus !== 1) {
          callback(rt.resultMessage || '请输入正确的课程号！')
        } else {
          callback()
        }
      })
    },
    updateUpload(obj = {}) {
      this.imageUrl = obj.imageUrl || this.imageUrl
      this.uploadLoading = obj.loading
    },
    // 课程码变化
    async courseCodeChange(code, cb) {
      let res = await this.$http.getAidedTeachCourseInfo({
        courseNo: code
      })
      cb && cb(res.rt || {})
      if (res.code === 200) {
        const { courseName, teacherInfos, courseImage } = res.rt || {}
        this.imageUrl = courseImage || ''
        let selectedTeacherId = ''
        this.teacherList = teacherInfos || []
        if (this.teacherList.length > 0) {
          selectedTeacherId = this.teacherList[0].userId
          this.selectedTeacher = this.teacherList[0]
        } else {
          selectedTeacherId = ''
          this.selectedTeacher = []
        }
        this.form.setFieldsValue({
          courseName: courseName || '',
          selectedTeacherId,
          h5DisplayContent: this.selectedTeacher.userName +' | '+ this.activityDetail.schoolName
        })
      }
    },
    // 选择老师
    handleSelectTeacherChange(e) {
      const { teacherList = [] } = this
      this.selectedTeacher = teacherList.find(i => i.userId === e)
      const h5DisplayContent = this.selectedTeacher.userName + ' | ' + this.activityDetail.schoolName
      this.form.setFieldsValue({
        h5DisplayContent,
        selectedTeacherId: e
      })
    },
    handleCancel() {
      const { modalData } = this
      this.updateUpload({loading: false})
      this.$emit('updateModalData', { ...modalData, show: false })
    },
    // 新建翻转课
    async handleOk() {
      const { courseCode,courseName, selectedTeacherId, h5DisplayContent } = this.form.getFieldsValue()
      if (this.uploadLoading) return
      this.form.validateFields(async (error, values) => {
        if (error) return
        const {
          modalData,
          courseItem,
          activityId,
          selectedTeacher = {},
          imageUrl
        } = this
        let res = {}
        const params = {
          activityId,
          courseNo: courseCode,
          teacherId: selectedTeacherId,
          teacherName: selectedTeacher.userName,
          h5DisplayContent,
          courseName,
          imageUrl
        }
        if (modalData.option === 'add') {
          res = await this.$http.createCourse(params)
        } else {
          res = await this.$http.editCourse({
            ...params,
            cardId: courseItem.cardId,
          })
        }

        if (res.code !== 200) return this.$message.error(`${modalData.option === 'add' ? '新建' : '编辑'}翻转课失败！`)
        if (res.rt.resultStatus === 1) {
          // 更新spoc课程列表
          this.$emit('getActiveDetail')
          this.$message.success(`${modalData.option === 'add' ? '新建' : '编辑'}翻转课成功！`)
        } else {
          return this.$message.error(res.rt.resultMessage || `${modalData.option === 'add' ? '新建' : '编辑'}翻转课失败！`)
        }

        this.$emit('updateModalData', { ...modalData, show: false })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .ant-modal-body{
    padding: 0;
  }
  .ant-form-item{
    margin-bottom: 18px;
  }
  .ant-form-item-with-help{
    margin-bottom: 0px
  }
}

.content-form{
  padding: 16px 0;
  .btn-update-cover{
    width: 160px;
    height: 90px;
    position: relative;
    border: 1px dashed #DCDEE0;
    background: #F6F8FA;
    background-repeat: no-repeat;
    background-size:cover;
    background-position: center center;
    .update-mask{
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      line-height: 30px;
      .icon-upload{
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url('../../../../assets/img/icon-plus2@2x.png') no-repeat;
        background-size: cover;
        &.icon-loading{
          background: none;
          border: 2px solid #969799;
          border-left: 2px solid transparent;
          border-radius: 100%;
          animation: loadingAni infinite 1s linear;
        }
      }
      .btn-text{
        color: #969799;
        margin: 0;
      }
    }
    .update-wrap{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      cursor: pointer;
      z-index: 1;

    }
    &.has-image{
      .update-mask{
        background-color: rgba(0, 0, 0, 0.5);
      }
      .btn-text{
        color: #fff;
      }
      .icon-upload{
        background-image: url('../../../../assets/img/icon-plus3@2x.png');
        &.icon-loading{
          border: 2px solid #fff;
          border-left: 2px solid transparent;
        }
      }
    }

  }
  .upload-cover-tip{
    font-size: 12px;
    color: #969799;
  }
}
.footer{
  border-top: 1px solid #E7E7E7;
  text-align: center;
  padding: 20px;
  .btn{
    display: inline-block;
    width: 104px;
    height: 38px;
    line-height: 38px;
    color: #5F60D3;
    border: 1px solid rgb(95, 96, 211);
    border-radius: 4px;
    cursor: pointer;
    &.btn-cancel{
      &:hover{
        opacity: 0.9;
        background: rgba(95,96,211,0.05)
      }
    }

    &.btn-ok{
      color: #fff;
      background: #5F60D3;
      margin-left: 16px;
      &:hover{
        opacity: 0.9;
      }
      &.btn-ok-disabled{
        background: #bbb;
        border-color: #bbb;
      }
    }

  }
}
@keyframes loadingAni {
  0% {
    transform: rotate(-180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
</style>

